module.exports = __webpack_public_path__ + "static/media/iot.1d440324.png";